var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidacaoVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M44,32A12,12,0,1,0,56,44,12,12,0,0,0,44,32Zm6.155,7.987L42.7,49.55c-.059.059-.155.188-.273.188a.394.394,0,0,1-.273-.155c-.07-.07-4.227-4.066-4.227-4.066l-.08-.08a.279.279,0,0,1,0-.343.7.7,0,0,0,.059-.064c.412-.434,1.248-1.312,1.3-1.366.07-.07.129-.161.257-.161s.22.112.284.177S42.163,46,42.163,46l5.962-7.661a.306.306,0,0,1,.188-.075.3.3,0,0,1,.188.07l1.639,1.291a.3.3,0,0,1,.07.188A.278.278,0,0,1,50.155,39.987Z",
    transform: "translate(-32 -32)",
    fill: "#009738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidacaoVerde);
export default __webpack_public_path__ + "static/media/validacao-verde.dd3c7c7da2de1b415b79d736dbcc9ee0.svg";
export { ForwardRef as ReactComponent };